// extracted by mini-css-extract-plugin
module.exports = {"singleRow":"permittedRooms_singleRow__1cBQZ","header":"permittedRooms_header__uyQtK","rowCell":"permittedRooms_rowCell__2u85O","cardHeader":"permittedRooms_cardHeader__35Fkn"};